import { useCallback, useMemo } from 'react';

import { ACTIONS } from '~/services/toasts/internalServerError';
import { useTestRunnerActionsState } from '~/views/TestDetails/components/TestActions/TestHeaderActions.hooks';

import { testsApi } from '../../tests.api';
import { showTestError } from '../../tests.utils';

export const useStopTestRecording = () => {
  const [stopRecording, stopRecordingState] = testsApi.useStopRecordingMutation();
  const { setPendingAction, resetPendingAction } = useTestRunnerActionsState();

  const handleStopRecording = useCallback(
    async (...params: Parameters<typeof stopRecording>) => {
      setPendingAction('stop');
      const result = stopRecording(...params).unwrap();

      result
        .catch((error) => {
          showTestError(ACTIONS.STOP_RECORD, error, true);
        })
        .finally(() => {
          resetPendingAction();
        });

      return result;
    },
    [resetPendingAction, setPendingAction, stopRecording],
  );

  return useMemo(
    () => [handleStopRecording, stopRecordingState] as const,
    [handleStopRecording, stopRecordingState],
  );
};
